var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"shop-container"},[_c('transition',[(_vm.showOrder)?_c('shopify',{attrs:{"order":_vm.order}}):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }